import OtpField from "@corvu/otp-field"
import { Show } from "solid-js"
import { caretClass, containerClass, slotRecipe } from "./otp-input.css"

type Props = {
  value: string
  onValueChange: (value: string) => void
  onComplete: () => void | Promise<void>
  disabled?: boolean
  error?: boolean
  ref?: HTMLInputElement | ((el: HTMLInputElement) => void)
}

export function OtpInput(props: Props) {
  return (
    <OtpField
      maxLength={6}
      value={props.value}
      onValueChange={props.onValueChange}
      onComplete={props.onComplete}
    >
      <OtpField.Input
        aria-label="Verification Code"
        name="otp"
        ref={props.ref}
        autocomplete="one-time-code"
        data-1p-ignore
      />
      <div class={containerClass}>
        <OtpSlot index={0} disabled={props.disabled} error={props.error} />
        <OtpSlot index={1} disabled={props.disabled} error={props.error} />
        <OtpSlot index={2} disabled={props.disabled} error={props.error} />
        <OtpSlot index={3} disabled={props.disabled} error={props.error} />
        <OtpSlot index={4} disabled={props.disabled} error={props.error} />
        <OtpSlot index={5} disabled={props.disabled} error={props.error} />
      </div>
    </OtpField>
  )
}

function OtpSlot(props: {
  index: number
  disabled?: boolean
  error?: boolean
}) {
  const context = OtpField.useContext()

  function char() {
    return context.value()[props.index]
  }

  function isActive() {
    return context.activeSlots().includes(props.index)
  }

  function showFakeCaret() {
    return context.value().length === props.index && context.isInserting()
  }

  return (
    <div
      class={slotRecipe({
        active: isActive(),
        disabled: props.disabled,
        error: props.error,
      })}
    >
      {char()}
      <Show when={showFakeCaret()}>
        <div class={caretClass} />
      </Show>
    </div>
  )
}
